'use client';

import React from 'react';
import InnerLayout from '~/components/InnerLayout';
import ElectionMenu from '~/components/ElectionMenu';
import RegionReports from './RegionReports';
import SlagReports from './SlagReports';
import { observer } from 'mobx-react';
import { getStore } from '~/mobx/AppStore';

type Props = {
    isCompany: boolean;
};

const Reports = (props: Props) => {
    const { isCompany } = props;
    const renderMainContent = () => {
        return isCompany ? <SlagReports /> : <RegionReports />;
    };

    return <InnerLayout className="reports-page" leftPanel={<ElectionMenu />} content={renderMainContent()} />;
};

const ReportsWithStore = () => {
    const { electionMenuStore } = getStore();
    const isCompany = electionMenuStore.getIsCompanyLevel();

    return <Reports isCompany={isCompany} />;
};

export default observer(ReportsWithStore);
